/** Compatibility facade for stable identifiers owned by dsh-coding-oauth-core,
 * plus Hub-only subscription routes (not in core CODING_OAUTH_ROUTES). */

export type { CodingOAuthOptionalRoute, CodingOAuthRoute } from "dsh-coding-oauth-core";

import type { CodingOAuthProviderSlug as CoreCodingOAuthProviderSlug } from "dsh-coding-oauth-core";

/** Core slugs plus Hub-local GitHub Copilot subscription OAuth. */
export type CodingOAuthProviderSlug = CoreCodingOAuthProviderSlug | "copilot";

export {
	ANTIGRAVITY_ROUTE,
	CAPABILITY_SETTINGS_NAMESPACE,
	CAPABILITY_SETTINGS_PATH,
	CLAUDE_CODE_OAUTH_AUTH_FILENAME,
	CLAUDE_CODE_OAUTH_MODELS_CACHE_FILENAME,
	CLAUDE_CODE_OAUTH_ROUTE,
	CLAUDE_PI_PROVIDER,
	CODEX_OAUTH_AUTH_FILENAME,
	CODEX_OAUTH_FAST_ROUTE,
	CODEX_OAUTH_MODELS_CACHE_FILENAME,
	CODEX_OAUTH_ROUTE,
	CODEX_PI_PROVIDER,
	CODEX_USAGE_PATH,
	CODING_OAUTH_LOGIN_CANCEL_PATH,
	CODING_OAUTH_LOGIN_CODE_PATH,
	CODING_OAUTH_LOGIN_PATH,
	CODING_OAUTH_LOGOUT_PATH,
	CODING_OAUTH_MANAGEMENT_PATHS,
	CODING_OAUTH_MODELS_PATH,
	CODING_OAUTH_OPTIONAL_ROUTES,
	CODING_OAUTH_ROUTES,
	CODING_OAUTH_STATE_SCHEMA_VERSION,
	CODING_OAUTH_STATUS_PATH,
	DEFAULT_GROK_BUILD_MODEL,
	GATEWAY_KEY_FILENAME,
	GATEWAY_REVEAL_PATH,
	GATEWAY_ROTATE_PATH,
	GATEWAY_SETTINGS_PATH,
	GROK_BUILD_AUTH_FILENAME,
	GROK_BUILD_AUTH_IMPORT_PATH,
	GROK_BUILD_AUTH_LOGIN_CANCEL_PATH,
	GROK_BUILD_AUTH_LOGIN_CODE_PATH,
	GROK_BUILD_AUTH_LOGIN_PATH,
	GROK_BUILD_AUTH_LOGOUT_PATH,
	GROK_BUILD_AUTH_MODELS_PATH,
	GROK_BUILD_AUTH_STATUS_PATH,
	GROK_BUILD_MODELS_CACHE_FILENAME,
	GROK_BUILD_ROUTE,
	GROK_BUILD_STREAM_IDLE_TIMEOUT_MS,
	IMAGINE_CREDENTIAL_STATUS_PATH,
	IMAGINE_MEDIA_STORE_DIRNAME,
	KIMI_CODE_OAUTH_AUTH_FILENAME,
	KIMI_CODE_OAUTH_MODELS_CACHE_FILENAME,
	KIMI_CODE_OAUTH_ROUTE,
	KIMI_PI_PROVIDER,
	OAUTH_IMPORT_CANCEL_PATH,
	OAUTH_IMPORT_COMMIT_PATH,
	OAUTH_IMPORT_PREVIEW_PATH,
	OAUTH_IMPORT_SOURCES_PATH,
	XAI_PI_PROVIDER,
} from "dsh-coding-oauth-core";

/** pi-ai native provider id for GitHub Copilot. */
export const GITHUB_COPILOT_PI_PROVIDER = "github-copilot";
/** Hub-local LLM route alias (not listed in core CODING_OAUTH_ROUTES). */
export const GITHUB_COPILOT_OAUTH_ROUTE = "github-copilot-oauth";
export const GITHUB_COPILOT_OAUTH_AUTH_FILENAME = ".github-copilot-oauth-auth.json";
export const GITHUB_COPILOT_OAUTH_MODELS_CACHE_FILENAME = ".github-copilot-oauth-models.json";

/** Hub-owned routes registered beside the core CODING_OAUTH_ROUTES set. */
export const HUB_CODING_OAUTH_EXTRA_ROUTES = [GITHUB_COPILOT_OAUTH_ROUTE] as const;
export type HubCodingOAuthExtraRoute = (typeof HUB_CODING_OAUTH_EXTRA_ROUTES)[number];
